import React from "react";
import { useNavigate } from "react-router-dom";
import { FaUsers, FaCalendarCheck, FaMoneyCheckAlt, FaArrowRight } from "react-icons/fa";
import { Building2, Settings2 } from "lucide-react";

const OrganizationLanding = [
  {
    title: "Add Organizations",
    subtitle: "Explore organization structure and details",
    icon: <Building2 size={32} />,
    gradient: "from-blue-500 to-blue-600",
    hoverGradient: "from-blue-600 to-blue-700",
    path: "/setup-organizations",
  },
  {
    title: "View & Edit Organizations",
    subtitle: "Manage and update organization configurations",
    icon: <Settings2 size={32} />,
    gradient: "from-emerald-500 to-emerald-600",
    hoverGradient: "from-emerald-600 to-emerald-700",
    path: "/view-org",

  },
];

const OrganizationLanding1 = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full mt-5 min-h-screen font-montserrat">
      {/* Header Section */}
     
      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {OrganizationLanding.map(
          (item, index) =>
              <div
                key={index}
                onClick={() => navigate(item.path)}
                className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden"
              >
                {/* Gradient Background on Hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${item.hoverGradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
                
                {/* Card Content */}
                <div className="relative p-6 flex flex-col h-full">
                  {/* Icon Container */}
                  <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <div className="text-white">
                      {item.icon}
                    </div>
                  </div>

                  {/* Text Content */}
                  <div className="flex-grow">
                    <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-white transition-colors duration-300">
                      {item.title}
                    </h3>
                    <p className="text-gray-500 text-sm group-hover:text-white/90 transition-colors duration-300">
                      {item.subtitle}
                    </p>
                  </div>

                  {/* Arrow Icon */}
                  <div className="mt-4 flex items-center text-gray-400 group-hover:text-white transition-colors duration-300">
                    <span className="text-sm font-medium mr-2">View Report</span>
                    <FaArrowRight className="group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </div>

                {/* Decorative Elements */}
                <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-white/5 rounded-full group-hover:bg-white/10 transition-colors duration-300" />
                <div className="absolute -right-8 -bottom-8 w-32 h-32 bg-white/5 rounded-full group-hover:bg-white/10 transition-colors duration-300" />
              </div>
          
        )}
      </div>

     
    </div>
  );
};

export default OrganizationLanding1;